<template>
  <footer class="footer">
    <div class="footer-container">
      <!-- COLUNA 1: Institucional -->
      <div class="col">
        <h3 class="empresa">{{ siteInfo.empresa }}</h3>
        <p class="descricao">
          {{ siteInfo.institucional.descricaoCurta }}
        </p>
      </div>

      <!-- COLUNA 2: Contato -->
      <div class="col">
        <h4>Contato</h4>
        <p><strong>Telefone:</strong> {{ siteInfo.telefone }}</p>
        <p><strong>E-mail:</strong> {{ siteInfo.email }}</p>
      </div>

      <!-- COLUNA 3: Newsletter -->
      <div class="col">
        <h4>Receba novidades</h4>
        <form @submit.prevent="enviarEmail">
          <input
            v-model="email"
            type="email"
            :placeholder="siteInfo.newsletter.placeholder"
            required
          />
          <button type="submit">Enviar</button>
        </form>
        <p v-if="mensagem" class="mensagem">{{ mensagem }}</p>
      </div>
    </div>

    <!-- RODAPÉ INFERIOR -->
    <div class="footer-bottom">
      <div class="socials">
        <a
          :href="siteInfo.redes.instagram"
          target="_blank"
          aria-label="Instagram"
        >
          <i class="bi bi-instagram"></i>
        </a>
        <a
          :href="siteInfo.redes.facebook"
          target="_blank"
          aria-label="Facebook"
        >
          <i class="bi bi-facebook"></i>
        </a>

        <!-- 🔹 WHATSAPP GLOBAL -->
        <a href="javascript:void(0)" @click="abrirPopupWhatsGlobal()" aria-label="WhatsApp">
          <i class="bi bi-whatsapp"></i>
        </a>
      </div>
      <p>{{ siteInfo.institucional.direitos }}</p>
    </div>
  </footer>
</template>

<script setup>
import { ref } from "vue";
import { siteInfo } from "@/config/siteInfo";
import { abrirPopupWhatsGlobal } from "@/utils";

const email = ref("");
const mensagem = ref("");

function enviarEmail() {
  if (email.value.includes("@")) {
    mensagem.value = siteInfo.newsletter.mensagemSucesso;
  } else {
    mensagem.value = siteInfo.newsletter.mensagemErro;
  }
  setTimeout(() => (mensagem.value = ""), 3000);
  email.value = "";
}
</script>

<style scoped>
.footer {
  background: #000;
  color: #f9f9f9;
  padding: 3.5em 1.5em 1.2em;
  border-top: 4px solid #ffc300;
  font-family: "Inter", sans-serif;
}

.footer-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 2.5em;
  max-width: 1100px;
  margin: 0 auto;
}

.col h3.empresa {
  color: #ffc300;
  font-weight: 800;
  font-size: 1.8rem;
  margin-bottom: 0.4em;
}

.col h4 {
  color: #ffc300;
  margin-bottom: 0.7em;
  font-weight: 700;
}

.col p {
  margin: 0.3em 0;
  color: #ddd;
  line-height: 1.5;
}

.descricao {
  max-width: 300px;
}

form {
  display: flex;
  flex-direction: column;
  gap: 0.8em;
}

input {
  padding: 0.7em 1em;
  border-radius: 8px;
  border: 1px solid #333;
  background: #111;
  color: #f9f9f9;
  outline: none;
  font-size: 0.95rem;
}

input::placeholder {
  color: #aaa;
}

button {
  background: linear-gradient(90deg, #ffc300, #ff2e79);
  color: #fff;
  border: none;
  padding: 0.7em 1.4em;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 600;
  transition:
    background 0.3s ease,
    transform 0.2s ease;
}

button:hover {
  transform: translateY(-2px);
  background: linear-gradient(90deg, #ffd13b, #ff568f);
}

.mensagem {
  font-size: 0.9em;
  color: #ffc300;
  margin-top: 0.5em;
}

/* 🔗 Redes sociais */
.footer-bottom {
  margin-top: 3em;
  text-align: center;
  border-top: 1px solid #222;
  padding-top: 1.5em;
}

.socials {
  margin-bottom: 1em;
}

.socials a {
  color: #ffc300;
  margin: 0 0.5em;
  font-size: 1.4rem;
  transition: color 0.3s ease;
  cursor: pointer;
}

.socials a:hover {
  color: #ff2e79;
}

.footer-bottom p {
  color: #aaa;
  font-size: 0.9rem;
}

@media (max-width: 768px) {
  .footer {
    padding: 2.5em 1em 1em;
  }
}
</style>
